module.exports = "/legacy/cd2b61e27e6ef830a13fd5d273f11672.svg";